import { useEffect, useState } from 'react';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import classNames from 'classnames';

import ImageC from 'src/components/Image';
import Skeleton from 'src/components/Skeleton';
import { IGameDetail } from 'src/interface';
import { isVideoUrl } from 'src/utils/func';

import classes from './index.module.less';

interface Props {
	data: IGameDetail['medias'];
	isLoading?: boolean;
}

const Screenshot = ({ data, isLoading = false }: Props) => {
	const [preview, setPreview] = useState<string>('');

	useEffect(() => {
		if (data?.[0]?.media_url && preview === '') {
			setPreview(data?.[0]?.media_url);
		}
	}, [data]);

	if (!isLoading && data?.length === 0) return null;

	return (
		<div className={classes.screenshots}>
			<Row gutter={30}>
				<Col xs={24} md={18} xl={20}>
					{isLoading ? (
						<Skeleton className={classes['media-preview']} />
					) : (
						<div className={classes['media-preview']}>
							{isVideoUrl(preview) ? (
								<video
									className={classes.img}
									preload="metadata"
									poster={`${preview}#t=0.1`}
									src={`${preview}#t=0.1`}
									autoPlay
									controls={true}
								/>
							) : (
								<ImageC alt="media preview" className={classes.img} src={preview} />
							)}
						</div>
					)}
				</Col>

				<Col xs={24} md={6} xl={4} style={{ position: 'relative' }}>
					<div className={classes['media-list']}>
						{isLoading
							? new Array(3)
									.fill({ id: 'loading' })
									?.map((_, index) => <Skeleton key={index} className={classes.media} />)
							: data?.map((media, index) => (
									// eslint-disable-next-line react/jsx-indent
									<div
										key={media.id}
										className={classNames(classes.media, {
											[classes.active]: media?.media_url === preview,
										})}
										onClick={() => setPreview(media?.media_url)}
									>
										<div className={classes['image-container']}>
											{isVideoUrl(media?.media_url) ? (
												<>
													<video
														className={classes.img}
														preload="metadata"
														poster={`${media?.media_url}#t=0.1`}
														src={`${media?.media_url}#t=0.1`}
													/>
													<ImageC
														alt={'icon play'}
														className={classes['icon-play']}
														src="/icons/icon-play-video.svg"
													/>
												</>
											) : (
												<ImageC
													alt={`media ${index}`}
													className={classes.img}
													src={media?.media_url}
												/>
											)}
										</div>
									</div>
								))}
					</div>
				</Col>
			</Row>
		</div>
	);
};

export default Screenshot;
